import { useMediaQuery, useTheme } from "@mui/material";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import { NavContainer } from "../NavContainer";

type RootScreenProps = {
  nav: React.ReactNode;
  main: React.ReactNode;
};

export function RootScreen({ nav, main }: RootScreenProps) {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("lg"));
  const [openNav, setOpenNav] = useState(matches);
  useEffect(() => {
    setOpenNav(!matches);
  }, [matches]);

  return (
    <Box
      sx={(theme) => ({
        position: "relative",
        marginInline: "auto",
        minHeight: "100vh",
        backgroundColor: "primary.dark",
        "& > nav": {
          position: "fixed",
          width: "260px",
          left: "-260px",
          top: 0,
          bottom: 0,
        },
        "& > main": {
          marginLeft: "0 ",
        },
        "& .menu-button": {
          display: "block",
        },
        [theme.breakpoints.up("lg")]: {
          "& .menu-button": {
            display: "none !important",
          },
          "& > nav": {
            left: "0 !important",
          },
          "& > main": {
            marginLeft: "260px !important",
          },
        },
      })}
    >
      <NavContainer>{nav}</NavContainer>
      {main}
    </Box>
  );
}

export default RootScreen;
